import React from "react";
import { IContentWrapperComponent } from "./content-wrapper.types";

const ContentWrapperComponent = ({ children }: IContentWrapperComponent) => {
  return <div className="h-full p-24">{children}</div>;
};

export default ContentWrapperComponent;
